// extracted by mini-css-extract-plugin
module.exports = {"desktopNavBar":"DesktopNavBar_desktopNavBar__2IB4y","sfx":"DesktopNavBar_sfx__ErQ57","soundEffects":"DesktopNavBar_soundEffects__kMi6P","newBadge":"DesktopNavBar_newBadge__6xAAW"};